import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function CTABand() {
  const { t, lang } = useLang();
  const cn = lang === 'zh' ? 'font-cn' : '';
  return (
    <section className="navy-gradient relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="absolute -bottom-20 -left-16 w-72 h-72 rounded-full bg-[#C6A15B]/10 blur-3xl" />
      <div className="max-w-5xl mx-auto px-5 lg:px-8 py-20 text-center relative reveal">
        <h2 className={`font-serif-display text-3xl md:text-4xl font-semibold text-white mb-4 text-balance ${cn}`}>
          {t('cta.title')}
        </h2>
        <p className={`text-white/70 max-w-2xl mx-auto mb-9 ${cn}`}>{t('cta.subtitle')}</p>
        <Link
          to="/contacto"
          className={`inline-flex items-center gap-2 gold-btn rounded-full px-8 py-4 font-semibold ${cn}`}
        >
          {t('cta.button')}
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
